<template>
  <div>
    <b-modal id="newWasherModal" title="New Washer">
      <div class="d-flex flex-column">
        <label>Name</label>
        <input v-model="newWasherName" type="text" class="form-control" />
      </div>
      <template #modal-footer>
        <div class="d-flex justify-content-end w-100">
          <b-button
            variant="primary"
            class="mr-2"
            :disabled="!validationFlag || validationFlag == null"
            @click="washerOperation(0,'add')"
            >Confirm</b-button
          >
          <b-button variant="secondary" @click="$bvModal.hide('newWasherModal')"
            >Cancel</b-button
          >
        </div>
      </template>
    </b-modal>
    <div class="d-flex justify-content-between">
      <breadCrumb
        :icon="'fa-car-wash'"
        :category="$t(`sideNav.navSalonSetting`)"
        :subCategory="$t(`subMenu.salon_setting_washer`)"
        :subSubCategory="''"
      >
      </breadCrumb>
      <div class="d-flex align-items-end">
        <b-button size="sm" v-b-modal.newWasherModal variant="primary"
          >Add New Washer</b-button
        >
      </div>
    </div>
    <div class="px-3 px-sm-5 py-4">
      <div class="panel mb-0">
        <div class="panel-hdr d-block pt-4 pb-4">
          <div class="row w-100">
            <div class="col-sm-12 col-md-4">
              <div class="form-group d-flex">
                <div class="input-group-prepend w-100">
                  <label
                    class="
                      input-group-text
                      border-top-right-radius-0
                      border-bottom-right-radius-0
                      border-right-0
                    "
                  >
                    <i class="fas fa-store"></i>
                  </label>
                  <multiselect
                    v-model="selectedOutlet"
                    label="text"
                    track-by="id"
                    :options="outlet"
                    :searchable="false"
                    :show-labels="false"
                    openDirection="below"
                    @select="filterByOutlet"
                  >
                    <template slot="option" slot-scope="{ option }">{{
                      option.text
                    }}</template>
                  </multiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-container">
          <div class="panel-content row">
            <template v-if="washerList.length > 0">
              <div
                class="col-sm-4 p-2"
                v-for="washer in washerList"
                :key="washer.washerID"
                :class="checked ? 'border border-success' : ''"
              >
                <div class="card">
                  <div class="d-flex">
                     <b-button-group class="w-100">
      <b-button class="rounded-0" style="border-radius:4px0 0 0 0;" @click="washerOperation(washer.washerID,'reset')" variant="success">Reset</b-button>
      <b-button class="rounded-0" style="border-radius:0 4px 0 0;" @click="washerOperation(washer.washerID,'delete')" variant="danger">Delete</b-button>
    </b-button-group>
                </div>
                <div class="card-body">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex">
                      <h4 class="mr-1">{{ washer.name }}</h4>
                      <b-icon icon=" fa-solid fa-arrow-rotate-right"></b-icon>
                    </div>

                  </div>
                  <div class="d-flex flex-column">
                    <span>Create Date: {{ washer.createDate }}</span>
                    <span>Last Seen: {{ washer.lastSeenDate }}</span>
                    <span>UUID: <b-button size="sm" variant="primary" @click="washerUUID = washer" v-b-modal.qrCodeModal pill>Display QR Code</b-button></span>
                  </div>
                </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div>No available Washers.</div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <b-modal @show="size=300" class="modal-xl" id="qrCodeModal">
      <div class="d-flex justify-content-center"><h4>{{washerUUID.name}}</h4></div>
        <div class="d-flex justify-content-center">
            <qrcode-vue :value="washerUUID.uuid" :size="size" level="H" />
        </div>
        <div class="d-flex w-100 mt-2 justify-content-center">
            <b-button-group>
      <b-button class="rounded-0" style="border-radius:4px0 0 0 0;" @click="size=300" variant="primary">1.0x</b-button>
      <b-button class="rounded-0" style="border-radius:0 4px 0 0;" @click="size=600" variant="primary">2.0x</b-button>
    </b-button-group>
        </div>
        <template #modal-footer>
                  <div class="d-flex justify-content-end w-100">
          <b-button variant="secondary" @click="$bvModal.hide('qrCodeModal')">Close</b-button>
        </div>
        </template>
    </b-modal>
  </div>
</template>

<script>
import { handleSessionExpired } from "../../../assets/js/dashboard/dashboard";
import BreadCrumb from "./../Bread_Crumb";
import moment from "moment";
  import QrcodeVue from 'qrcode.vue'

export default {
  name: "washer",
  components: {
    BreadCrumb,
    QrcodeVue
  },
  data() {
    return {
      outlet: [],
      selectedOutlet: 0,
      newWasherName: "",
      validationFlag: false,
      checked: false,
      washerList: [],
      size:300,
      washerUUID:""
    };
  },
  watch: {
    newWasherName(val) {
      if (val == "") {
        this.validationFlag = false;
      } else {
        this.validationFlag = true;
      }
    },
  },
  methods: {
    toastrExe(title, body, variant) {
      this.$bvToast.toast(body, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    closeModal(isError) {
      if (!isError) {
        this.getSocialMedia();
      }
      this.$parent.isModalShow = false;
    },
    filterByOutlet(item) {
      this.selectedOutlet = item;
      this.getWasherList(this.selectedOutlet);
    },
    async washerOperation(washerID,operation) {
      let body = { name: this.newWasherName };
      let t = "";
      let b = ""; 
      let url = this.$api.BEBUSINESS_OUTLET + this.selectedOutlet.id + "/washers";
        if(operation=='reset'){
            url +=`/${washerID}/reset`;
            body={};
            t="Reset";
            b=`Successfully reset washer ID:${washerID}`;
        }
        else if(operation=='delete'){
            url +=`/${washerID}/delete`;
            body={};
            t="Delete Car Wash";
            b=`Successfully delete washer ID:${washerID}`;
        }
        else{
            t="Add Washer";
            b=`Successfully add new car wash to outlet ID:${this.selectedOutlet.id}`;
        }
      let result = [];
      
      await this.$axios({
        method: "post",
        url: url,
        data: body,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      if (result.status == 200) {
        this.toastrExe(
          t,
          b,
          "success"
        );
        await this.getWasherList(this.selectedOutlet);
      } else {
        this.toastrExe(t, "Update failed.", "danger");
      }
    },
    async getWasherList(outlet) {
      let url = this.$api.BEBUSINESS_OUTLET + outlet.id + "/washers";
      let result = [];
      await this.$axios({
        method: "get",
        url: url,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response.data.washers;
          result.forEach((r) => {
            r.createDate = moment(new Date(r.createDate * 1000)).format(
              "DD/MM/YYYY"
            );
            r.lastSeenDate =
              r.lastSeenDate == 0
                ? "-"
                : moment(new Date(r.lastSeenDate * 1000)).format("DD/MM/YYYY");
          });
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      this.washerList = result;
    },
  },
  mounted() {
    let $vm = this;
    $vm.outlet = JSON.parse($vm.$store.state.outlets);
    $vm.selectedOutlet = $vm.outlet[0];
    $vm.getWasherList($vm.selectedOutlet);
  },
};
</script>

<style scoped>
.img-input-group {
  padding: 0.5rem 0.65rem;
}
.img-social {
  width: 1.5em;
}
.activeWasher {
  box-shadow: rgba(13, 207, 59, 0.3) 0px 19px 38px,
    rgba(18, 244, 10, 0.22) 0px 15px 12px;
}
.activeWasher:after {
  box-shadow: rgba(13, 207, 59, 0.3) 0px 19px 38px,
    rgba(18, 244, 10, 0.22) 0px 15px 12px;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
}
</style>